import React, { useMemo } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useTypedSelector } from 'store/index';
import { showAuth, showDetail } from 'components/auth';
import OneKeyAuth from 'components/oneKeyAuth/index';
import Tooltip from 'components/tooltip';
import './index.scss';
import ToggleBindApp from 'components/appBindinng/ToggleBindApp';
import { Category } from 'pages/manage/application/constants';
import OrderCardList from 'pages/application-list/OrderCardList';
// @ts-ignore
// import { activeAccountType } from 'common/const';

const ApplicationList = (): JSX.Element => {
  const history = useHistory();
  const {
    user: { user, myApp, roles, loading },
  } = useTypedSelector((state) => state);

  let visibleApps = useMemo(() => myApp.filter((item) => !item.no_authorize), [myApp]);

  visibleApps = visibleApps.filter((item) => [Category.adEfficiency, Category.privateDomain].includes(item.category));

  if (!loading && !user) {
    history.push('/');
    return null;
  }

  const authPrivilege = roles?.includes(100) || roles?.includes(10) || user?.auto_activation_authed_status;
  const authButton = (id: string, name: string) =>
    authPrivilege ? (
      <span className="rect-button" role="button" onClickCapture={() => showAuth(id)}>
        立即开通
      </span>
    ) : (
      <span className="rect-button" role="button" onClickCapture={() => showDetail(id, name)}>
        申请开通
      </span>
    );

  const openYzf = () => {
    window.open(
      'https://yzf.qq.com/xv/web/static/chat/index.html?sign=37ef9b97d32600c2214498ea14b3b867f34309055de14b8dc0a1596a1c52772ca70682e18c97e443e70db8f922c8c6cb0eb8'
    );
  };

  // const canSeeAppUserList = [activeAccountType.isvAgency, activeAccountType.proxyAgency, activeAccountType.ader];
  // const canSeeApp = canSeeAppUserList.includes(user?.active_account_type);
  const canSeeApp = true; // 现在能登陆进来的人都能看到管理中心

  return (
    <div>
      <div style={{ height: '72px' }} />
      <OneKeyAuth />
      <main className="application-list-page">
        {canSeeApp && (
          <div className="text-bold header">
            <Tooltip popover="仅展示广告投放工具相关开通状态；私域和RTA工具无需开通，可直接使用">应用开通管理</Tooltip>
          </div>
        )}

        {canSeeApp &&
          visibleApps?.map(
            ({
              app_name,
              app_icon,
              client_id,
              authorize_status,
              super_admin_status,
              client_bind_status,
              authorize_account_count,
            }) => (
              <div key={app_name} className="application">
                <Link to={`/application/${client_id}`} data-track="app-detail">
                  <img src={app_icon} alt="" />
                </Link>
                <div className="name">
                  <Link className="text-bold" to={`/application/${client_id}`} data-track="app-detail">
                    {app_name}
                  </Link>
                  <div className="status-content">
                    <span className={`status ${authorize_status ? 'authed' : ''}`}>
                      {/* eslint-disable-next-line no-nested-ternary */}
                      {!!authorize_status
                        ? super_admin_status === 2
                          ? '全部账户开通'
                          : `${authorize_account_count}个账户开通`
                        : '未开通'}
                    </span>
                    {!!authorize_status && (
                      <span className="view-detail" onClickCapture={() => showDetail(client_id, app_name)}>
                        查看
                      </span>
                    )}
                  </div>
                </div>
                <div className="btn-group">
                  <ToggleBindApp client_id={client_id} isBind={client_bind_status === true} />
                  {!authorize_status && authButton(client_id, app_name)}
                  {super_admin_status === 1 && (
                    <span className="rect-button" role="button" onClickCapture={() => showAuth(client_id)}>
                      开通/更新
                    </span>
                  )}
                </div>
              </div>
            )
          )}

        <div className="text-bold header" style={{ paddingTop: '30px' }}>
          发布需求管理
          {/* <Tooltip popover="仅展示广告投放工具相关开通状态；私域和RTA工具无需开通，可直接使用">发布需求管理</Tooltip>*/}
        </div>
        <OrderCardList />
      </main>

      <aside>
        <div className="item consult">
          <span role="button" />
          <div className="tip-wrapper">
            <span
              style={{ cursor: 'pointer', fontWeight: 'bolder', color: '#fff', paddingBottom: '8px', width: '80px' }}
              id="yzf-btn"
              onClick={openYzf}
            >
              在线咨询
            </span>
          </div>
        </div>
        <div className="item roll-top">
          <span role="button" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} />
          <div className="tip-wrapper">返回顶部</div>
        </div>
      </aside>
    </div>
  );
};

export default ApplicationList;
